import React from 'react'
// @ts-ignore
import { Lightbox as LightboxComponent } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { LightboxProps } from './types'

const Lightbox = ({
  isOpen,
  onClose,
  defaultIndex,
  slides,
  placeholders
}: LightboxProps): React.ReactElement => {
  const theme = useDisplayTheme()
  return (
    <LightboxComponent
      isOpen={isOpen}
      slides={slides}
      defaultIndex={defaultIndex}
      onClose={onClose}
      mode={theme}
      placeholders={placeholders}
    />
  )
}

export default Lightbox
